import { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { Box, Portal } from '@mui/material';
import PendingRequestsReminder from './PendingRequestsReminder';

const ReviewActionsContext = createContext(null);

export function LocationReviewActionsProvider({ children, pendingCount = 0, ...reminderProps }) {
  const [container, setContainer] = useState(null);
  const [hasReview, setHasReview] = useState(false);
  const [locationLabel, setLocationLabel] = useState('');
  const context = useMemo(() => ({ container, setHasReview, setLocationLabel }), [container]);
  return (
    <ReviewActionsContext.Provider value={context}>
      {children}
      {(pendingCount > 0 || hasReview) && (
        <PendingRequestsReminder
          {...reminderProps}
          pendingCount={pendingCount}
          reviewLocationLabel={hasReview ? locationLabel : ''}
          reviewAction={<Box ref={setContainer} sx={{ minWidth: 0, display: hasReview ? 'block' : 'none' }} />}
        />
      )}
    </ReviewActionsContext.Provider>
  );
}

export function LocationReviewAction({ children, locationLabel = '' }) {
  const context = useContext(ReviewActionsContext);
  const setHasReview = context?.setHasReview;
  const setLocationLabel = context?.setLocationLabel;
  useLayoutEffect(() => {
    if (!setHasReview) return undefined;
    setHasReview(true);
    return () => setHasReview(false);
  }, [setHasReview]);
  useLayoutEffect(() => {
    setLocationLabel?.(locationLabel);
    return () => setLocationLabel?.('');
  }, [setLocationLabel, locationLabel]);

  if (!context) return <PendingRequestsReminder pendingCount={0} reviewAction={children} reviewLocationLabel={locationLabel} />;
  return context.container ? <Portal container={context.container}>{children}</Portal> : null;
}
